<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { $api } from '@/services';
import router from '@/router';
import { useRoute } from 'vue-router';

const props = defineProps(['assementName']);
const emit = defineEmits(['close']);
const route = useRoute();
const name = ref('');
const store = useStore();
watch(
	() => props.assementName,
	(newVal) => {
		name.value = newVal;
	},
	{ immediate: true }
);
const submit = async () => {
	try {
		const res = await $api.form.updateFormForStudent(
			route.params.id,
			route.query.formId,
			{
				student_assessment_form: {
					name: name.value,
				},
			}
		);
		if (res) {
			await store.dispatch('setAlertMessage', {
				message: 'Đổi tên bản đánh giá thành công',
				type: 'success',
			});
			emit('close');
		}
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};
</script>
<template>
	<div class="_invite-employee _modal bg-white">
		<div
			class="
				_modal__content
				px-12
				py-6
				flex flex-col
				items-center
				justify-center
			"
		>
			<div>
				<img
					src="@/assets/images/illustrations/edit.png"
					alt="Luca Education"
					title="Luca Education"
					height="60"
					width="60"
				/>
			</div>
			<div
				class="
					_modal__content__title
					text-neutral-700
					font-semibold
					text-2xl
					mt-5
				"
			>
				Đổi tên bản Đánh giá phát triển
			</div>
			<div class="w-full mt-10">
				<div class="input-group flex items-center">
					<div
						class="
							input-group__label
							text-neutral-400
							font-semibold
							w-2/5
							uppercase
						"
					>
						Tên bản đánh giá
					</div>
					<input
						type="text"
						placeholder="Nhập tên bản đánh giá"
						v-model="name"
					/>
				</div>
			</div>
		</div>
		<div
			class="
				_modal__footer
				px-12
				py-6
				bg-neutral-50
				flex flex-nowrap
				items-center
			"
		>
			<button
				type="button"
				class="
					button-p
					text-center
					mr-3
					bg-none
					shadow-none
					text-neutral-500
					hover:text-neutral-700
				"
				@click="$emit('close')"
			>
				Thoát
			</button>
			<button
				type="button"
				class="button-p text-center whitespace-nowrap"
				:disabled="!name"
				@click="submit"
			>
				Xác nhận
			</button>
		</div>
	</div>
</template>
